// 400+ unique airport-transfer blog entries, one per Swiss city/town.
// Each entry has a unique slug: flughafentransfer-nach-<citySlug>
import { POPULAR, REGIONS, slugify } from "./cities";

const seen = new Set();
const all = [];

POPULAR.forEach((c) => {
  if (!seen.has(c.slug)) {
    seen.add(c.slug);
    all.push({ citySlug: c.slug, name: c.name, region: "Beliebte Orte", image: c.image });
  }
});

REGIONS.forEach((r) => {
  r.cities.forEach((name) => {
    const s = slugify(name);
    if (!seen.has(s)) {
      seen.add(s);
      all.push({ citySlug: s, name, region: r.region });
    }
  });
});

// Neighbouring-country destinations
const NEIGHBOURS = [
  "Konstanz", "Freiburg im Breisgau", "Lörrach", "Friedrichshafen", "München", "Stuttgart",
  "Mulhouse", "Colmar", "Strassburg", "Annecy", "Chamonix", "Lyon",
  "Como", "Mailand", "Domodossola", "Varese", "Aostatal",
  "Innsbruck", "Bregenz", "Feldkirch", "Salzburg", "Wien",
  "Vaduz", "Schaan",
];
NEIGHBOURS.forEach((name) => {
  const s = slugify(name);
  if (!seen.has(s)) {
    seen.add(s);
    all.push({ citySlug: s, name, region: "Nachbarländer" });
  }
});

// Additional Swiss municipalities to broaden coverage
const EXTRA_CH = [
  "Uster","Dübendorf","Dietikon","Wädenswil","Horgen","Kloten","Bülach","Wetzikon","Volketswil","Illnau-Effretikon",
  "Regensdorf","Opfikon","Wallisellen","Adliswil","Meilen","Küsnacht","Thalwil","Schlieren","Affoltern am Albis","Pfäffikon",
  "Rüti","Stäfa","Männedorf","Wangen-Brüttisellen","Embrach","Fällanden","Zollikon","Herrliberg","Bassersdorf","Elgg",
  "Muri bei Bern","Ostermundigen","Köniz","Ittigen","Zollikofen","Münsingen","Belp","Lyss","Nidau","Langenthal",
  "Burgdorf","Spiez","Steffisburg","Worb","Wohlen bei Bern","Frutigen","Saanen","Gstaad","Adelboden","Kandersteg",
  "Riggisberg","Schwarzenburg","Aarberg","Interlaken","Meiringen","Grindelwald","Lauterbrunnen","Wengen","Mürren","Brienz",
  "Reinach","Muttenz","Allschwil","Pratteln","Münchenstein","Binningen","Liestal","Sissach","Laufen","Aesch",
  "Wettingen","Baden","Brugg","Zofingen","Lenzburg","Rheinfelden","Aarau","Wohlen","Menziken","Muri",
  "Bremgarten","Möhlin","Frick","Kaiseraugst","Suhr","Buchs AG","Oftringen","Spreitenbach","Neuenhof","Klingnau",
  "Emmen","Kriens","Horw","Ebikon","Sursee","Hochdorf","Willisau","Wolhusen","Weggis","Vitznau",
  "Küssnacht","Arth","Goldau","Schwyz","Einsiedeln","Freienbach","Lachen","Altdorf","Andermatt","Stans",
  "Engelberg","Sarnen","Giswil","Wil","Uzwil","Gossau","Rorschach","Altstätten","Buchs SG","Sargans",
  "Bad Ragaz","Flums","Wattwil","Rapperswil-Jona","Amriswil","Arbon","Kreuzlingen","Frauenfeld","Weinfelden","Romanshorn",
  "Bischofszell","Herisau","Appenzell","Teufen","Gais","Chur","Landquart","Ilanz","Thusis","Arosa",
  "Flims","Laax","Lenzerheide","Klosters","Scuol","Zuoz","Samedan","Pontresina","Zernez","Disentis",
  "Splügen","Bellinzona","Mendrisio","Chiasso","Biasca","Airolo","Faido","Ascona","Minusio","Muralto",
  "Vevey","Montreux","Morges","Nyon","Rolle","Gland","Renens","Pully","Yverdon-les-Bains","Aigle",
  "Bex","Villars","Leysin","Château-d'Oex","Payerne","Estavayer","Bulle","Gruyères","Charmey","Murten",
  "Sitten","Sierre","Martigny","Monthey","Visp","Brig","Saas-Fee","Verbier","Crans-Montana","Leukerbad",
  "Delémont","Pruntrut","Saignelégier","La Chaux-de-Fonds","Le Locle","Neuenburg","Val-de-Travers","Solothurn","Grenchen","Olten",
];
EXTRA_CH.forEach((name) => {
  const s = slugify(name);
  if (!seen.has(s)) {
    seen.add(s);
    all.push({ citySlug: s, name, region: "Weitere Orte" });
  }
});

export const TRANSFER_POSTS = all.map((c) => ({
  ...c,
  slug: `flughafentransfer-nach-${c.citySlug}`,
  title: `Flughafentransfer nach ${c.name}`,
}));

export const TRANSFER_PREFIX = "flughafentransfer-nach-";

// Grouped by region for listing pages
export const TRANSFER_GROUPS = (() => {
  const groups = {};
  TRANSFER_POSTS.forEach((p) => {
    (groups[p.region] = groups[p.region] || []).push(p);
  });
  return Object.entries(groups).map(([region, posts]) => ({ region, posts }));
})();
